import styled from '@emotion/styled';
import tw from 'twin.macro';
import Button from './Button';

const BlueText = styled(Button)`
  ${tw`text-blue-3 hover:text-gray-800 transition-all duration-200`}
`;

export default BlueText;
